  const loader = `<svg
    class="loader flo-loader"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
  <path
    d="M8.50004 1.33325V3.99992M8.50004 11.9999V14.6666M4.50004 7.99992H1.83337M15.1667 7.99992H12.5M13.219 12.7189L11.3334 10.8333M13.219 3.33321L11.3334 5.21883M3.78109 12.7189L5.66671 10.8333M3.78109 3.33321L5.66671 5.21883"
    stroke="#111"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  </svg>`

  function appendCss() {
    let css = `
	.loader {
		display: block;
		animation: rotate 1.5s linear infinite;
	}

     .loader-container {
       display: flex;
       justify-content: center;
       align-items: center;
       width: 100%;
       height: 100%;
     }

     .loader-container > .loader {
       height: 16px !important;
       width: 16px !important;
     }

	@keyframes rotate {
		100% {
			transform: rotate(360deg);
		}
	}

	.flo-disabled-text-color {
		cursor: not-allowed;
	}

	#logout-button-desktop,
	#logout-button-mobile,
	#account-button-desktop {
		cursor: pointer;
        font: inherit;
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 8px;
		font-size: 14px;
		color: #344054;
		font-style: normal;
		font-weight: 500;
		line-height: 20px;
		width: 100%;
		border-radius: 8px;
		padding: 8px 8px;
		border: none;
		background: var(--base-white, #fff);
	}

    #logout-button-desktop>p {
      margin: 0;
      padding: 0;
    }

	#loggedin-icons {
		align-self: center;
		display: none;
	}

	#loggedin-icons-mobile {
		display: none;
	}

	#shopflo-drawer-desktop{
		padding: 4px;
		display: none;
		right: 0%;
		position: absolute;
		width: 8rem;
		top: 100%;
		box-shadow: 0px 1px 4px 0px #00000040;
		border-radius: 8px;
		z-index: 999;
		background: #fff !important;
	}

#shopflo-drawer-mobile{
		padding: 4px;
		display: none;
		left: 0%;
		position: absolute;
		width: 10rem;
		bottom: 100%;
		box-shadow: 0px 1px 4px 0px #00000040;
		border-radius: 8px;
		z-index: 999;
		background: #fff !important;
	}

	#shopflo-drawer-desktop>ul,
	#shopflo-drawer-mobile>ul {
		margin: 0px 0px 0px 0px;
		padding: 0;
		width: 100%;
	}

	#shopflo-drawer-desktop>ul>a,
	#shopflo-drawer-mobile>ul>a {
		cursor: pointer;
		width: 100%;
		display: flex !important;
		align-items: baseline;
  justify-content: center;

		padding: 0;
		color: inherit;
        height: 38px;
		margin-left: 0 !important;
		text-decoration: none;
	}

	#shopflo-drawer-desktop>ul>a:hover,
	#shopflo-drawer-mobile>ul>a:hover,
	#shopflo-drawer-desktop>ul>a:focus,
	#shopflo-drawer-mobile>ul>a:focus {
		text-decoration: none;
	}

	#shopflo-drawer-desktop>ul>a:focus,
	#shopflo-drawer-mobile>ul>a:focus,
	#shopflo-drawer-desktop>ul>a:active,
	#shopflo-drawer-mobile>ul>a:active {
		text-decoration: none;
	}

	#shopflo-drawer-desktop>ul>a:focus .loader-container,
	#shopflo-drawer-mobile>ul>a:focus .loader-container {
		display: flex;
	}

 	#shopflo-drawer-desktop>ul>a:focus p,
	#shopflo-drawer-mobile>ul>a:focus p {
		display: none;
	}

	#shopflo-drawer-desktop>ul>a:not(:focus) .loader-container,
	#shopflo-drawer-mobile>ul>a:not(:focus) .loader-container {
		display: none;
	}

    #shopflo-drawer-desktop>ul>a:not(:focus) p,
	#shopflo-drawer-mobile>ul>a:not(:focus) p {
		display: block;
	}

	#shopflo-drawer-desktop>ul>a>p,
	#shopflo-drawer-mobile>ul>a>p {
		font-size: 14px;
		font-style: normal;
		font-weight: 500;
		line-height: 142.857%;

		display: inline-flex;
		gap: 8px;
		align-items: center;
		margin: 10px 0 10px 0;
		color: #000;
	}

	.header--icon,
	.header--icon--mobile {
		cursor: pointer;
		position: relative;
		display: inline-flex;
		color: inherit;
		margin-top: 2px;
	}

	#icon-close-shopflo,
	#icon-close-shopflo-mobile {
		display: none;
		border-radius: 50px;
		border: 1px solid white;
		margin: 0;
		padding: 2px;
		align-items: center;
		justify-content: center;
	}

	path#svgkp-path {
		stroke-width: 0.1;
	}

	svg.loader.flo-loader {
		position: relative !important;
	}

	.header--icon--mobile {
		display: none;
	}

  `;

    var style = document.createElement('style');
    style.innerHTML = css;
    document.getElementsByTagName('head')[0].appendChild(style);
  }

  appendCss()

  const userIcon = `
    <svg width="25" height="25" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg" class="flo-icon">
      <g clip-path="url(#clip0_1997_6385)">
        <rect width="29" height="29" />
        <g stroke="currentColor">
          <path d="M4.83331 25.375V22.9583C4.83331 21.6765 5.34254 20.4471 6.24896 19.5407C7.15539 18.6342 8.38477 18.125 9.66665 18.125H12.6875"  stroke-width="1.61111" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14.5 13.2917C17.1694 13.2917 19.3334 11.1277 19.3334 8.45833C19.3334 5.78896 17.1694 3.625 14.5 3.625C11.8306 3.625 9.66669 5.78896 9.66669 8.45833C9.66669 11.1277 11.8306 13.2917 14.5 13.2917Z" stroke-width="1.61111" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <path d="M21.3865 12.3001L14.1711 20.6166L20.5136 20.7427L19.6967 26.3665L26.9122 18.05L20.5697 17.9238L21.3865 12.3001Z" fill="#01CCA7" stroke="#01CCA7" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    </svg>

  `

  const shopfloNotLoggedIcon = `<div id="flo-login-button-header-logo" style="cursor: pointer;display: flex;align-items: center;">${userIcon}</div>`

  const shopfloNotLoggedIconMobile = `<div id="flo-login-button-header-logo-mobile" style="cursor: pointer;display: flex">${userIcon}</div>`

  const drawerhtmlDesktop = `<div id="shopflo-drawer-desktop" >
  <ul>
  <a id="account-button-desktop" href="javascript:void(0);" onclick="handleShopifyLogin(event,'/account')" style=" display: flex">
    <p>
      Account
    </p>
    <div class="loader-container"> 
      ${loader}
    </div>
  </a>

  </ul>
    <button id="logout-button-desktop">
      <p>
        Log out
      </p>
    </button>
  </div>`;

  const drawerhtmlMobile = `<div id="shopflo-drawer-mobile">
  <ul>
  <a href="javascript:void(0);" onclick="handleShopifyLogin(event,'/account')" display: flex">
    <p>
      Account
    </p>
   <div class="loader-container"> 
      ${loader}
    </div>
  </a>
  </ul>
    <button id="logout-button-mobile">
      <p>
        Logout
      </p>
    </button>
  </div>`;



  const shopfloLoggedInIcon = `
    <div id="loggedin-icons" >
      <div id="icon-close-shopflo" class="icon-close-shopflo" style="height: 25px; width:25px; cursor: pointer;" onclick="handleDrawer()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18M6 6L18 18" stroke="black" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div style="cursor: pointer;display: flex;" onclick="handleDrawer()" id="icon-shopflo">
        ${userIcon}
      </div>
    </div>`;

  const shopfloLoggedInIconMobile = `
  <div id="loggedin-icons-mobile">
    <div id="icon-close-shopflo-mobile" style="cursor: pointer;" onclick="handleDrawer()">
      <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </div> 
      <div style="cursor: pointer;display: flex" onclick="handleDrawer()" id="icon-shopflo-mobile">
      ${userIcon}
    </div>
  </div>`;

  const profileButtonElement = document.querySelector('.x-container-header-icons a[href*="/account"]')
  const personIconElement = profileButtonElement?.parentElement;  
  const html = `
    ${shopfloNotLoggedIcon}
    ${shopfloLoggedInIcon}        
    ${drawerhtmlDesktop}
  `;

  if (!document.getElementsByClassName("header--icon")?.[0]) {
    const shopflossoDesktopNode = document.createElement('div')
    shopflossoDesktopNode.className = "header--icon"
    shopflossoDesktopNode.innerHTML = html
    if (personIconElement && profileButtonElement) {
      personIconElement.replaceChild(shopflossoDesktopNode, profileButtonElement)
    }
  }

  const profileButtonElementMbl = document.querySelector('.x-block-login a[href*="/account"]')
  const personIconElementMbl = profileButtonElementMbl?.parentElement;
  console.log(profileButtonElementMbl, personIconElementMbl)
  const htmlmobile = `
    ${shopfloNotLoggedIconMobile}
    ${shopfloLoggedInIconMobile}        
    ${drawerhtmlMobile}
  `;

  if (!document.getElementsByClassName("header--icon--mobile")?.[0]) {
    const shopflossoMobileNode = document.createElement('div')
    shopflossoMobileNode.className = "header--icon--mobile"
    shopflossoMobileNode.innerHTML = htmlmobile
    if (personIconElementMbl && profileButtonElementMbl) {
      personIconElementMbl.replaceChild(shopflossoMobileNode, profileButtonElementMbl)
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
	console.log(document.querySelector('.x-block-login a[href*="/account"]'))
});
